require('./infiniteCarouselController');
require('../resize/resizeDirective');

"use strict";

angular.module('app.shared.infiniteCarousel.infiniteCarouselDirective', [
    'app.shared.infiniteCarousel.infiniteCarouselController',
    'app.shared.resize.resizeDirective'
  ])
    .directive('infiniteCarousel', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/shared/infiniteCarousel/infiniteCarouselView.html',
                controller: 'app.shared.infiniteCarousel.infiniteCarouselController',
                scope: {
                    listTemplate: '=',
                    items: '=',
                    itemWidth: '=',
                    onItemClick: '=?'
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/infiniteCarousel/infiniteCarouselDirective.js